import React from "react";
import { Modal } from "react-bootstrap";

const WELCOME_PAGE_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "860px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0
  },
  modalBody: {
    padding: "22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  heroCard: {
    borderRadius: "22px",
    padding: "22px",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.06) 0%, rgba(79, 70, 229, 0.08) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "18px"
  },
  heroDate: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "999px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 1)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 800,
    marginBottom: "16px"
  },
  heroHeadline: {
    fontSize: "28px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
    marginBottom: "10px"
  },
  heroSubtext: {
    fontSize: "14px",
    lineHeight: 1.7,
    color: "#475569",
    margin: 0
  },
  letterCard: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "22px"
  },
  greeting: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "16px"
  },
  paragraph: {
    fontSize: "14px",
    lineHeight: 1.85,
    color: "#475569",
    marginBottom: "14px"
  },
  highlightCard: {
    borderRadius: "18px",
    background: "linear-gradient(135deg, rgba(248,250,252,1) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(226, 232, 240, 1)",
    padding: "16px 18px",
    margin: "18px 0"
  },
  highlightTitle: {
    fontSize: "13px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px"
  },
  highlightList: {
    margin: 0,
    paddingLeft: "18px",
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.8
  },
  signatureBlock: {
    marginTop: "22px",
    paddingTop: "18px",
    borderTop: "1px solid rgba(226, 232, 240, 1)"
  },
  signatureLabel: {
    fontSize: "13px",
    color: "#64748b",
    marginBottom: "8px"
  },
  signatureName: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a"
  },
  signatureRole: {
    fontSize: "13px",
    color: "#475569",
    marginTop: "4px"
  }
};

const WelcomePage = ({ welShowHide, handleWelShowHide, userDetails }) => {
  const fullName = [userDetails?.performername, userDetails?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <Modal
      show={welShowHide}
      size="lg"
      centered
      onHide={handleWelShowHide}
      dialogClassName="welcome-page-modal-dialog"
      contentClassName="welcome-page-modal-content"
    >
      <style>
        {`
          .welcome-page-modal-dialog {
            max-width: ${WELCOME_PAGE_STYLES.modalDialog.maxWidth};
          }
          .welcome-page-modal-content {
            border-radius: ${WELCOME_PAGE_STYLES.modalContent.borderRadius};
            overflow: ${WELCOME_PAGE_STYLES.modalContent.overflow};
            border: ${WELCOME_PAGE_STYLES.modalContent.border};
            box-shadow: ${WELCOME_PAGE_STYLES.modalContent.boxShadow};
          }
        `}
      </style>
      <Modal.Header style={WELCOME_PAGE_STYLES.modalHeader}>
        <div style={WELCOME_PAGE_STYLES.headerContent}>
          <Modal.Title as="div" style={WELCOME_PAGE_STYLES.titleWrap}>
            <div style={WELCOME_PAGE_STYLES.headerIcon}>
              <i className="fa fa-handshake-o" aria-hidden="true"></i>
            </div>
            <div>
              <div style={WELCOME_PAGE_STYLES.title}>Welcome to IPCS</div>
              <div style={WELCOME_PAGE_STYLES.subtitle}>
                A quick introduction to the portal and the digital-first experience ahead.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={WELCOME_PAGE_STYLES.closeButton}
            onClick={handleWelShowHide}
            aria-label="Close welcome message"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>
      <Modal.Body style={WELCOME_PAGE_STYLES.modalBody}>
        <div style={WELCOME_PAGE_STYLES.heroCard}>
          <div style={WELCOME_PAGE_STYLES.heroDate}>
            <i className="fa fa-calendar-o" aria-hidden="true"></i>
            1 July 2025
          </div>
          <div style={WELCOME_PAGE_STYLES.heroHeadline}>
            A new digital portal for onboarding, contracts, time logs, invoicing, and payments.
          </div>
          <p style={WELCOME_PAGE_STYLES.heroSubtext}>
            We are refining our business model and modernizing core processes to improve efficiency,
            collaboration, and visibility for customers, partners, and staff.
          </p>
        </div>

        <div style={WELCOME_PAGE_STYLES.letterCard}>
          <div style={WELCOME_PAGE_STYLES.greeting}>
            Dear {fullName || "Partner"},
          </div>

          <p style={WELCOME_PAGE_STYLES.paragraph}>
            As part of our business transformation effort, we are refining our business models and
            redesigning processes to enhance efficiency and strengthen collaboration with our
            customers, partners, and staff.
          </p>

          <p style={WELCOME_PAGE_STYLES.paragraph}>
            Beginning on 1 July 2025, our operations will be collaboratively managed through our
            new digital portal. This includes candidate and subcontractor onboarding, contract
            management, time logs, invoicing, and payment processing.
          </p>

          <div style={WELCOME_PAGE_STYLES.highlightCard}>
            <div style={WELCOME_PAGE_STYLES.highlightTitle}>What this portal helps streamline</div>
            <ul style={WELCOME_PAGE_STYLES.highlightList}>
              <li>Candidate and subcontractor onboarding</li>
              <li>Contract management and collaboration</li>
              <li>Time log, invoicing, and payment workflows</li>
            </ul>
          </div>

          <p style={WELCOME_PAGE_STYLES.paragraph}>
            We are confident this digital-first approach will help us work more efficiently and
            create more room for innovation across our shared processes.
          </p>

          <p style={{ ...WELCOME_PAGE_STYLES.paragraph, marginBottom: 0 }}>
            We are thrilled to welcome you to the portal, and we appreciate your continued
            partnership.
          </p>

          <div style={WELCOME_PAGE_STYLES.signatureBlock}>
            <div style={WELCOME_PAGE_STYLES.signatureLabel}>Sincerely</div>
            <div style={WELCOME_PAGE_STYLES.signatureName}>Kuldeep Dhar</div>
            <div style={WELCOME_PAGE_STYLES.signatureRole}>CEO</div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WelcomePage;
